import React, { useRef, useEffect } from "react";
import "./DeleteCourseModal.css"; // Reusing the same CSS file for consistent styling
import StandardModal from "../shared/Modal/StandardModal";

function DeleteCourseModal({ isOpen, onClose, course, onConfirmDelete }) {
  const deleteButtonRef = useRef(null);

  useEffect(() => {
    if (isOpen && deleteButtonRef.current) {
      // Small delay to ensure modal is fully rendered
      const timer = setTimeout(() => {
        deleteButtonRef.current.focus();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleDelete = () => {
    if (onConfirmDelete) {
      onConfirmDelete();
    }
  };

  if (!course) return null;

  return (
    <StandardModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Course"
      footerCenter={
        <>
          <button
            ref={deleteButtonRef}
            className="btn btn-md btn-danger"
            onClick={handleDelete}
          >
            Delete Course
          </button>
        </>
      }
    >
      <div className="delete-course-modal">
        <div className="delete-course-modal-confirmation-message">
          <p>Are you sure you want to delete the course:</p>
          <div className="delete-course-modal-course-title">{course.title}</div>
          <p>This action cannot be undone.</p>
        </div>
      </div>
    </StandardModal>
  );
}

export default DeleteCourseModal;
